import { COOKIES, URL_PARAMETERS_THAT_MAY_CONTAIN_PROMO_CODES } from '@belong/constants';
import { setCookie } from '@belong/cookies';
import type { TSSPChain } from '@belong/ssp-execution';
import { TPublicSSPContext } from './types';

const getPromoCodeFromResolvedUrl = (resolvedUrl: string): string | undefined => {
  if (!resolvedUrl) {
    return undefined;
  }

  // base URL is required to parse the resolvedUrl, it isn't used for anything other than parsing the query parameters
  const baseUrl = 'https://belong.com.au';
  const url = new URL(resolvedUrl, baseUrl);

  for (let i = 0; i < URL_PARAMETERS_THAT_MAY_CONTAIN_PROMO_CODES.length; i += 1) {
    const param = URL_PARAMETERS_THAT_MAY_CONTAIN_PROMO_CODES[i];
    const valueInParam = url.searchParams.get(param);

    if (valueInParam) {
      return valueInParam;
    }
  }

  return undefined;
};

export const promoCodeSSP: TSSPChain<TPublicSSPContext> = async ctx => {
  const promoCode = getPromoCodeFromResolvedUrl(ctx.context.resolvedUrl ?? '');

  /*
   * When users from ISelect, etc get sent to our site, they land on pages with plans on them.
   * This is when we read their URL for a parameter to store for auto-applying in the promo
   * code screen later on in the signup process.
   */

  if (promoCode) {
    setCookie(
      COOKIES.PROMO_CODE,
      promoCode,
      {
        path: '/',
        httpOnly: false,
        sameSite: 'strict'
      },
      ctx.context
    );
  }

  // return the unmodified context since we don't need to pass any data to the pageProps
  // we just need to ensure the cookie is set for future requests
  return ctx;
};
